import { render, staticRenderFns } from "./NsAuthFooter.vue?vue&type=template&id=2fd2c3e2&scoped=true&"
import script from "./NsAuthFooter.vue?vue&type=script&lang=js&"
export * from "./NsAuthFooter.vue?vue&type=script&lang=js&"
import style0 from "./NsAuthFooter.vue?vue&type=style&index=0&id=2fd2c3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2c3e2",
  null
  
)

export default component.exports